export const _ADD       = "lJKvZYuxRhO8KGYREp50KLpi+KZqTKnvxU4QYkqLa64=";
export const _EDIT      = "G7U3Eh1rvxqTjdGgk1/jjOoTAu0Aqod9DmTMcdOEoAw=";
export const _VIEW      = "f6PtMIXNBoitfY4yHVqxa8iPaOnVv0nOHE70mdTCqhk=";
export const _DELETE    = "8AU6e3k8EUVOk3dQWSRowZBYgH/L1OZyDi2+/BDrQww=";
export const _RECOVER   = "xBeZIPhkipLYMXFEoz6E1NfABeGlNHNZuH4eCBMWaD4=";
export const _LIST      = "uCs6Ii2xacFVayPtYoeTXJHkw17f26b/y1YFg62g1MI=";
export const _TRASH     = "jDQYVCMawCuRBhzWCuq2YBPGH9Ao3Sua/8xmjLkEkHs=";